<template>
  <div>
    <ca-heading text="Cálculo de férias individual" />

    <ca-row v-if="!isValidPeriod && boxInformationPeriodInfo">
      <ca-col>
        <ca-box-information
          :alert.sync="boxInformationPeriodInfo">
        </ca-box-information>
      </ca-col>
    </ca-row>

    <ca-row>
      <ca-col size="3">
        <div v-ca-tooltip="calculateButtonTooltipMessage">
          <ca-button
            theme="secondary"
            :disabled="!isValidPeriod"
            @click="onAddRelease">
            Adicionar lançamentos
          </ca-button>
        </div>
      </ca-col>
    </ca-row>

    <ca-page class="ca-u-margin-top">
      <ca-loader v-if="showLoading"></ca-loader>

      <ca-form
        v-else
        :key="formKey"
        :on-submit="onSubmit"
        :on-submit-success="onSubmitSuccess"
        :on-submit-error="onSubmitError"
        :error-message="errorMessage">
        <ca-row>
          <ca-col>
            <ca-box-information
              :alert.sync="boxInformationDisregardedDates">
            </ca-box-information>
          </ca-col>
        </ca-row>

        <ca-row>
          <ca-col>
            <ca-box-information
              :alert.sync="boxInformationErrorMessage">
            </ca-box-information>
          </ca-col>
        </ca-row>
        <br />

        <ca-row>
          <ca-col size="9">
            <ca-row>
              <ca-col size="6">
                <worker-select v-model="workerId" required></worker-select>
              </ca-col>
              <ca-col size="3">
                <ca-field label="Data de saída">
                  <ca-date-input
                    v-model="initialVacationDate"
                    required></ca-date-input>
                </ca-field>
              </ca-col>

              <ca-col size="3">
                <ca-field label="Dias de férias">
                  <ca-input
                    v-model="individualCalc.qntDias"
                    min="1"
                    max="99999"
                    type="number"
                    required
                    @change.self="onDaysChange">
                  </ca-input>
                </ca-field>
              </ca-col>
            </ca-row>

            <ca-row>
              <ca-col size="3">
                <ca-field label="Dias Abono">
                  <ca-number-input
                    v-model="individualCalc.allowanceDaysQuantity"
                    :custom-validations="mustBeBetweenOneAndTen" />
                </ca-field>
              </ca-col>

              <ca-col size="3">
                <ca-field label="Data do Fim">
                  <ca-date-input
                    v-model="individualCalc.endDate"
                    required
                    disabled>
                  </ca-date-input>
                </ca-field>
              </ca-col>

              <ca-col size="3">
                <ca-field label="Data do retorno">
                  <ca-date-input
                    v-model="individualCalc.dtRetorno"
                    required
                    disabled>
                  </ca-date-input>
                </ca-field>
              </ca-col>

              <ca-col size="3">
                <ca-field label="Data do pagamento">
                  <ca-date-input
                    v-model="individualCalc.dtPagamento"
                    required
                    :on-change="checkPeriod">
                  </ca-date-input>
                </ca-field>
              </ca-col>

              <ca-col size="3">
                <ca-field label="Início Per. Aquisitivo">
                  <ca-date-input v-model="individualCalc.dtIniPerAq" required></ca-date-input>
                </ca-field>
              </ca-col>

              <ca-col size="3">
                <ca-field label="Fim Per. Aquisitivo">
                  <ca-date-input v-model="individualCalc.dtFimPerAq" required></ca-date-input>
                </ca-field>
              </ca-col>

              <ca-col size="3">
                <ca-field label="Nº Per. Aq">
                  <ca-input
                    v-model="individualCalc.nperAq"
                    min="0"
                    type="number"
                    required></ca-input>
                </ca-field>
              </ca-col>
            </ca-row>
            <ca-row>
              <ca-col size="6">
                <ca-field
                  label="Acrescentar o período de afastamento por suspensão"
                  icon-tooltip="Os dias de afastamento por suspensão do contrato
             de trabalho serão projetados na data fim do período aquisitivo.">
                  <ca-checkbox
                    v-model="considersLeaveOfAbsenceDays" />
                </ca-field>
              </ca-col>
            </ca-row>
          </ca-col>
          <ca-col size="3">
            <ca-row>
              <ca-col size="12">
                <disregarded-date-input
                  :vacation-leaving-date="individualCalc.dtSaida"
                  :vacation-days="parseInt(individualCalc.qntDias)"
                  :disregarded-dates="individualCalc.disregardedDates"
                  @change="updateDisregardedDates">
                </disregarded-date-input>
              </ca-col>
            </ca-row>
          </ca-col>
        </ca-row>

        <ca-footer>
          <ca-row vertical-offset="2">
            <ca-col size="2">
              <ca-button full-width @click="goBack">
                Voltar
              </ca-button>
            </ca-col>
            <ca-col offset="8" size="2">
              <div v-ca-tooltip="calculateButtonTooltipMessage">
                <ca-submit-button :disabled="!isValidPeriod">
                  Salvar
                </ca-submit-button>
              </div>
            </ca-col>
          </ca-row>
        </ca-footer>
      </ca-form>
    </ca-page>
  </div>
</template>

<script>
import {
  getBoxInformationCalculationMessageError,
  initFormObject,
} from 'packages/common/utils';
import { checkPeriodMixin } from 'packages/common/mixins/check-period/CheckPeriodMixin.js';

import {
  individualVacationCalculation,
  getVacation,
  getFormattedResponse,
  getAdditionalVacationInformation,
  getCalculatedAllowanceDays,
  getEndDate,
  getReturnDate,
  validateDisregardedDates,
  getBoxInformationDisregardedDates,
} from './vacationsService';

import AddReleaseModal from './modals/AddReleaseModal';
import DisregardedDateInput from './components/DisregardedDateInput';

import { DISREGARDED_DATES_ERROR } from './constants';

export default {
  name: 'VacationsIndividualFormPage',
  components: {
    DisregardedDateInput,
  },
  mixins: [checkPeriodMixin({ initialCheck: false })],
  data() {
    return {
      formKey: 0,
      individualCalc: {
        ...initFormObject(),
        movimentos: [],
        allowanceDaysQuantity: '',
        disregardedDates: [],
      },
      vacationId: this.$route.params.id,
      workerId: this.$route.params.workerId,
      errorMessage: null,
      initialVacationDate: null,
      considersLeaveOfAbsenceDays: false,
      mustBeBetweenOneAndTen: [{
        message: 'Deve ser de 1 a 10',
        valid(value) {
          return value >= 1 && value <= 10;
        },
      }],
      boxInformationDisregardedDates: null,
      boxInformationErrorMessage: null,
    };
  },
  computed: {
    returnDate() {
      return this.individualCalc.dtRetorno;
    },
    totalDays() {
      return this.individualCalc.qntDias;
    },
    hasVacationId() {
      return this.vacationId >= 0;
    },
    showLoading() {
      return this.hasVacationId && this.individualCalc.loading;
    },
    calculateButtonTooltipMessage() {
      return this.isValidPeriod
        ? ''
        : 'Você está dentro de um período fechado e não é possível realizar o cálculo';
    },
    saveButtonTooltipMessage() {
      return this.isValidPeriod
        ? ''
        : 'Você está dentro de um período fechado e não é possível realizar este lançamento';
    },
  },
  watch: {
    initialVacationDate(date) {
      this.individualCalc.dtSaida = date;
      if (this.workerId) {
        this.setExtraInfo(date);
      }
    },
    considersLeaveOfAbsenceDays() {
      if (this.workerId && this.individualCalc.dtSaida) {
        this.setExtraInfo(this.initialVacationDate);
      }
    },
  },
  created() {
    this.initData();
  },
  methods: {
    refreshForm() {
      this.formKey++;
    },
    checkPeriod() {
      this.checkPeriodValidation(this.individualCalc.dtPagamento);
    },
    async setExtraInfo(date) {
      getAdditionalVacationInformation(
        this.workerId, date, this.considersLeaveOfAbsenceDays
      )
        .then(data => {
          const { disregardedDates } = this.individualCalc;
          this.individualCalc = {
            ...this.individualCalc,
            ...getFormattedResponse(data),
          };

          if (this.individualCalc.disregardedDates.length === 0) {
            this.$set(this.individualCalc, 'disregardedDates', disregardedDates);
          }

          if (data.indAbono === 'sim' && data.allowanceDaysQuantity == null) {
            this.onAllowanceChange();
          }
        });
    },
    onDaysChange() {
      const { dtSaida: leavingDate, qntDias, disregardedDates } = this.individualCalc;

      if (leavingDate) {
        const days = disregardedDates.length + parseInt(qntDias);
        this.$set(this.individualCalc, 'dtRetorno', getReturnDate(leavingDate, days));
        this.$set(this.individualCalc, 'endDate', getEndDate(this.individualCalc.dtRetorno, 1));
      }
    },
    initData() {
      if (this.hasVacationId) {
        this.setIndividualCalc();
      }
    },
    async setIndividualCalc() {
      const response = await getVacation(this.vacationId);
      this.individualCalc = getFormattedResponse(response);
      this.initialVacationDate = this.individualCalc.dtSaida;
      this.individualCalc.funcionario = parseInt(this.workerId);
    },
    goBack() {
      this.$router.push({ name: 'VacationPage' });
    },
    onSubmit() {
      this.boxInformationDisregardedDates = null;
      this.boxInformationErrorMessage = null;
      const { disregardedDates, dtSaida, qntDias } = this.individualCalc;
      if (!validateDisregardedDates(disregardedDates, dtSaida, qntDias)) {
        return Promise.reject(new Error(DISREGARDED_DATES_ERROR));
      }
      return individualVacationCalculation(this.workerId, this.individualCalc);
    },
    onSubmitSuccess() {
      this.goBack();
      this.$toaster.success('Dados salvos com sucesso');
    },
    onSubmitError(error) {
      if (error.message === DISREGARDED_DATES_ERROR) {
        this.boxInformationDisregardedDates = getBoxInformationDisregardedDates();
      } else {
        this.boxInformationErrorMessage = getBoxInformationCalculationMessageError(error);
      }
    },
    onAddRelease() {
      this.$dialogModal(AddReleaseModal, {
        props: {
          movements: this.individualCalc.movimentos,
        },
        on: {
          'update-movements': movements => this.$set(this.individualCalc, 'movimentos', movements),
        },
      }).open();
    },
    async onAllowanceChange() {
      this.individualCalc.allowanceDaysQuantity = this.individualCalc.indAbono === 'sim'
        ? await getCalculatedAllowanceDays(this.workerId, this.individualCalc)
        : '';
      this.refreshForm();
    },
    updateDisregardedDates(disregardedDates) {
      this.$set(this.individualCalc, 'disregardedDates', disregardedDates);
      const days = disregardedDates.length + parseInt(this.individualCalc.qntDias);
      const returnDate = getReturnDate(this.individualCalc.dtSaida, days);
      this.$set(this.individualCalc, 'dtRetorno', returnDate);
      this.$set(this.individualCalc, 'endDate', getEndDate(returnDate, 1));
    },
  },
};
</script>
